<template>
  <div class="r-panel" :class="split && `split-${split}`">
    <slot></slot>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "panel",
  mixins: [],
  extends: {},
  data() {
    return {};
  },
  model: {
    /**
     *
     * 2.2.0 新增
     * 允许一个自定义组件在使用 v-model 时定制 prop 和 event。默认情况下，一个组件上的 v-model 会把 value 用作 prop 且把 input 用作 event，但是一些输入类型比如单选框和复选框按钮可能想使用 value prop 来达到不同的目的。使用 model 选项可以回避这些情况产生的冲突。
     */
    prop: "value",
    event: "input"
  },
  props: {
    split: [String, Number]
  },
  computed: {},
  mounted() {},
  methods: {},
  watch: {
    /*
      'a': {
        immediate: true,
        deep: true,
        handler (v) {}
      }
    */
  },
  methods: {
    handle() {}
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  // eslint-disable-next-line
  errorCaptured(err, vm, info) {
    /**
     * 2.5.0+ 新增
     * (err: Error, vm: Component, info: string) => ?boolean
     * 当捕获一个来自子孙组件的错误时被调用。此钩子会收到三个参数：错误对象、发生错误的组件实例以及一个包含错误来源信息的字符串。此钩子可以返回 false 以阻止该错误继续向上传播。
     */
  },
  directives: {},
  filters: {},
  components: {}
};
</script>
<style type="text/css" lang="less"></style>
